import { ComponentFactoryResolver, ComponentRef, Directive, Input, OnInit, ViewContainerRef } from '@angular/core';

import { ValValidationComponent } from './val-validation.component';
import { ValValidatorComponent } from './val-validator.component';


@Directive({
  selector: '[valValidator],[valvFunctionRef],[valvMessage],[valvCustomData]'
})

export class ValValidatorDirective implements OnInit {
  private _hidden = false;
  private _message: string = null;
  private _cRef: ComponentRef<ValValidatorComponent>;
  @Input('valValidator') type: "required" | "email" | "phone" | "number" | "date" | "custom";
  @Input('valvFunctionRef') funcionRef: (value: any, customData: any) => boolean;
  @Input('valvMessage') set message(x: string) {
    this._message = x;
    if (this._cRef) {
      this._cRef.instance.message = this.message;
    }
  }
  get message() { return this._message; }
  @Input('valvCustomData') customData: any;
  public set hidden(x: boolean) {
    this._hidden = x;
    if (this._cRef) {
      this._cRef.instance.hidden = x;
    }
  }
  public get hidden() { return this._hidden; }
  constructor
    (
      private _validationComponent: ValValidationComponent,
      private _componentFactoryResolver: ComponentFactoryResolver
    ) { }
  ngOnInit(): void {
    this._validationComponent.validators.push(this);
  }
  validate(value: any): boolean {
    let re: RegExp;
    switch (this.type) {
      case "required":
        return value ? true : false;
      case "email":
        re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(value);
      case "phone":
        re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
        return re.test(value);
      case "number":
        return parseFloat(value) ? true : false;
      case "date":
        return (new Date(value)) ? true : false;
      case "custom":
        return this.funcionRef(value, this.customData);
      default:
        return true;
    }
  }

  public show = (vc: ViewContainerRef) => {
    this._cRef = vc.createComponent(ValValidatorComponent);
    this._cRef.instance.message = this.message;
    this._cRef.instance.hidden = this._hidden;
  }
}
